<div
  class="flex ui-card gap-3 w-full m-0 p-3 alert-card alert-border-{{
    message.severity
  }}">
  <div class="flex items-start">
    <span
      class="material-symbols-outlined icon-small text-{{ message.severity }}">
      {{ message.icon }}
    </span>
  </div>
  <div class="flex flex-col w-full gap-2 text-gray-1000">
    <!-- Alert Header   -->
    <div class="flex gap-3 justify-between items-center">
      <div class="b3">{{ message.summary }}</div>
      @if (message.timestamp) {
        <span class="c1 text-gray-800">{{ message.timestamp }}</span>
      }
    </div>
    <!-- Alert Content   -->
    @if (message.description) {
      <div class="b1" [innerHTML]="message.description"></div>
    }
    <ng-content></ng-content>
    <!-- Alert Footer   -->
    <div class="flex items-center gap-3 justify-end">
      @for (action of secondaryActions; track action) {
        <m-button type="secondary" (click)="publishAction(action.eventId)">
          <div class="b1">{{ action.label }}</div>
        </m-button>
      }
      @for (action of primaryActions; track action) {
        <m-button type="primary" (click)="publishAction(action.eventId)">
          <div class="b1">{{ action.label }}</div>
        </m-button>
      }
    </div>
  </div>
</div>
